module.exports = __webpack_public_path__ + "static/office-ac709adde107eddcb3643f4b8f840077.jpg";